
import React, { useState, useEffect, useContext } from 'react'
import AdminSideBar from "../../components/adminSideBar/AdminSideBar";
import { useNavigate, useParams } from 'react-router-dom';
import { AgenceContext } from '../../context/agenceContext/AgenceContext';
import { EnvoieContext } from '../../context/envoieContext/EnvoieContext';
import { getOneEnvoie, updateEnvoie } from '../../context/envoieContext/apiCalls';
import ErrorComponent from '../../components/errorComponent/ErrorComponent';
import LoadingComponent from '../../components/loadingComponent/LoadingComponent';
import { communes, currentStatusEnvois, NatureEnvois, typeDeliveries, typeEnvois, typeRamassages, wilayas } from '../../data';
import FormRadio from '../../components/formRadio/FormRadio';
import FormInput from '../../components/formInput/FormInput';
import DropDownComponent from '../../components/dropDownComponent/DropDownComponent';
import { getAgencesByWilaya } from '../../context/agenceContext/apiCalls';
import { AuthContext } from '../../context/authContext/AuthContext';


function DetailEnvoie() {
    const [typeEnvoie, setTypeEnvoie] = useState("");
    const [typeDelivery, setTypeDelivery] = useState("");
    const [typeRamassage, setTypeRamassage] = useState("");
    const [errorBox, setErrorBox] = useState("");
    const { dispatch: dispatchAgence, agencesByWilaya } = useContext(AgenceContext);
    const { dispatch, envoie, isFetchingGet, errorGet, } = useContext(EnvoieContext);
    const { user } = useContext(AuthContext);

    const { id } = useParams();
    const navigate = useNavigate();

    /*  Sender */
    const [nomSender, setNomSender] = useState("");
    const [emailSender, setEmailSender] = useState("");
    const [tel1Sender, setTel1Sender] = useState("");
    const [tel2Sender, setTel2Sender] = useState("");
    const [wilayaSender, setWilayaSender] = useState(wilayas[0]);
    const [agenceSender, setAgenceSender] = useState({});
    const [addressSender, setAddressSender] = useState("");

    /*  Receiver  */
    const [nomReceiver, setNomReceiver] = useState("");
    const [emailReceiver, setEmailReceiver] = useState("");
    const [tel1Receiver, setTel1Receiver] = useState("");
    const [tel2Receiver, setTel2Receiver] = useState("");
    const [wilayaReceiver, setWilayaReceiver] = useState(wilayas[0]);
    const [communeReceiver, setCommuneReceiver] = useState(communes[0][0]);
    const [addressReceiver, setAddressReceiver] = useState("");
    const [agenceReceiver, setAgenceReceiver] = useState({});

    /*  Details  */
    const [description, setDescription] = useState("");
    const [number, setNumber] = useState("");
    const [montant, setMontant] = useState("");
    const [nature, setNature] = useState(NatureEnvois[0]);
    const [weight, setWeight] = useState("");
    const [cost, setCost] = useState("");


    useEffect(() => {
        getOneEnvoie(dispatch, id);
    }, [id])

    useEffect(() => {
        getAgencesByWilaya(dispatchAgence);
    }, [])

    useEffect(() => {
        window.scroll({ top: 0, left: 0, behavior: 'smooth' })
    }, [errorBox])

    useEffect(() => {
        if (envoie && Object.keys(envoie).length !== 0) {
            setTypeEnvoie(typeEnvois.filter(item => item.id === envoie.typeEnvoie)[0]);
            setTypeDelivery(typeDeliveries.filter(item => item.id === envoie.typeDelivery)[0]);

            /* Sender */
            setNomSender(() => {
                // if (envoie.Entreprise) {
                //     return envoie.Entreprise.nom || "";
                // } else {
                //     return envoie.User.Userinfo.nom || "";
                // }
                return envoie.nomDeparture
            });
            setEmailSender(() => {
                // if (envoie.Entreprise) {
                //     return envoie.Entreprise.email || "";
                // } else {
                //     return envoie.User.Userinfo.email || "";
                // }
                return envoie.emailDeparture
            });
            setTel1Sender(() => {
                // if (envoie.Entreprise) {
                //     return envoie.Entreprise.tel1 || "";
                // } else {
                //     return envoie.User.Userinfo.tel1 || "";
                // }
                return envoie.tel1Departure
            });
            setTel2Sender(() => {
                // if (envoie.Entreprise) {
                //     return envoie.Entreprise.tel2 || "";
                // } else {
                //     return envoie.User.Userinfo.tel2 || "";
                // }
                return envoie.tel2Departure
            });
            setWilayaSender(() => {
                return wilayas.filter(item => item.id === envoie.wilayaDeparture)[0] || wilayas[0];
            });

            setTypeRamassage(typeRamassages.filter(item => item.id === envoie.typeRamassage)[0]);
            setAddressSender(envoie.addressDeparture || "");
            envoie.agenceDeparture && setAgenceSender(agencesByWilaya.filter(item => item.id === envoie.agenceDeparture)[0])

            /* Receiver */
            setNomReceiver(envoie.nomArrived || "");
            setEmailReceiver(envoie.emailArrived || "");
            setTel1Receiver(envoie.tel1Arrived || "");
            setTel2Receiver(envoie.tel2Arrived || "");
            setWilayaReceiver(wilayas.filter(item => item.id === envoie.wilayaArrived)[0]);
            setCommuneReceiver(communes[envoie.wilayaArrived].filter(item => item.id === envoie.communeArrived)[0]);
            setAddressReceiver(envoie.addressArrived || "");
            envoie.agenceArrived && setAgenceReceiver(agencesByWilaya.filter(item => item.id === envoie.agenceArrived)[0]);

            /*  Details  */
            setDescription(envoie.description);
            setNumber(envoie.numero);
            setMontant(`${envoie.montant}`);
            setNature(NatureEnvois.filter(item => item.id === envoie.nature)[0]);
            setWeight(envoie.weight);
            setCost(`${envoie.cost}`);
        }
    }, [envoie])


    return (
        <div className='container-global'>
            <AdminSideBar activeTab="envoie" />
            <div className='center'>
                <div className="title">
                    <span className="material-symbols-rounded">shoppingmode</span>
                    {/* <span>Detail Envoie : NWE-{envoie?.id}</span> */}
                    <span>Detail Envoie : {envoie.currentStatus && (currentStatusEnvois.filter(item => item.id === envoie.currentStatus)[0]['nom'])}-{envoie?.tracking}</span>
                </div>

                {errorBox !== "" && (<div style={{ marginBottom: "25px" }} className='box-error'>{errorBox}</div>)}

                {
                    errorGet ? <ErrorComponent error={errorGet} /> : (
                        isFetchingGet ? <LoadingComponent /> : (
                            !envoie ? <span className='no-data'>Envoie Introuvable</span> : (
                                <div className="content envoie">
                                    <div className="box inactive">
                                        <div className="box-title">Type d'Envoie :</div>
                                        <div className="box-content">
                                            <FormRadio data={typeEnvois} itemChoisir={typeEnvoie} setItemChoisir={setTypeEnvoie} name='type-envoie' />
                                        </div>
                                    </div>
                                    <div className='big-box'>
                                        {/* Sender */}
                                        <div className="box inactive">
                                            <div className="box-title">Expéditeur :</div>
                                            <div className="box-content">
                                                <div className='side-to-side-envoie'>
                                                    <FormInput label='Nom *' itemInput={nomSender} setItemInput={setNomSender} auth inactive />
                                                </div>
                                                <FormInput label='Email' itemInput={emailSender} setItemInput={setEmailSender} auth inactive />
                                                <div className='side-to-side-envoie' >
                                                    <FormInput label='Tel 1 *' itemInput={tel1Sender} setItemInput={setTel1Sender} auth inactive />
                                                    <FormInput label='Tel 2' itemInput={tel2Sender} setItemInput={setTel2Sender} auth inactive />
                                                </div>
                                                <DropDownComponent data={wilayas} itemChoisir={wilayaSender} setItemChoisir={setWilayaSender} inactive />
                                                <FormRadio data={typeRamassages} itemChoisir={typeRamassage} setItemChoisir={setTypeRamassage} name='type-ramassage' />
                                                {
                                                    typeRamassage.id === 2 ? (
                                                        <DropDownComponent data={[agenceSender]} itemChoisir={agenceSender} setItemChoisir={setAgenceSender} inactive />
                                                    ) : (
                                                            <FormInput label='Adresse Départ *' itemInput={addressSender} setItemInput={setAddressSender} auth inactive />
                                                        )
                                                }
                                            </div>
                                        </div>
                                        {/* Receiver */}
                                        <div className="box inactive">
                                            <div className="box-title">Destinataire :</div>
                                            <div className="box-content">
                                                <div className='side-to-side-envoie'>
                                                    <FormInput label='Nom *' itemInput={nomReceiver} setItemInput={setNomReceiver} auth />
                                                    {/* <FormInput label='Prenom *' itemInput={prenomReceiver} setItemInput={setPrenomReceiver} auth /> */}
                                                </div>
                                                <FormInput label='Email' itemInput={emailReceiver} setItemInput={setEmailReceiver} auth />
                                                <div className='side-to-side-envoie'>
                                                    <FormInput label='Tel 1 *' itemInput={tel1Receiver} setItemInput={setTel1Receiver} auth />
                                                    <FormInput label='Tel 2' itemInput={tel2Receiver} setItemInput={setTel2Receiver} auth />
                                                </div>
                                                <DropDownComponent data={wilayas} itemChoisir={wilayaReceiver} setItemChoisir={setWilayaReceiver} />
                                                <FormRadio data={typeDeliveries} itemChoisir={typeDelivery} setItemChoisir={setTypeDelivery} name='type-delivery' />
                                                {
                                                    typeDelivery.id === 1 ? (
                                                        <>
                                                            <DropDownComponent data={communes[wilayaReceiver.id]} itemChoisir={communeReceiver} setItemChoisir={setCommuneReceiver} />
                                                            <FormInput label='Adresse *' itemInput={addressReceiver} setItemInput={setAddressReceiver} auth />
                                                        </>
                                                    ) : (
                                                        <DropDownComponent data={[{ nom: "Choisir Agence", id: 0, }, ...(agencesByWilaya.filter(item => item.wilaya === wilayaReceiver.id))]} itemChoisir={agenceReceiver} setItemChoisir={setAgenceReceiver} />
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    {/* Details */}
                                    <div className="box inactive">
                                        <div className="box-title">Détails :</div>
                                        <div className="box-content">
                                            <FormInput label='Description *' itemInput={description} setItemInput={setDescription} auth />
                                            <div className='side-to-side-envoie'>
                                                <FormInput label='Numero' itemInput={number} setItemInput={setNumber} auth />
                                                <FormInput label='Montant *' itemInput={montant} setItemInput={setMontant} auth />
                                            </div>
                                            <FormRadio data={NatureEnvois} itemChoisir={nature} setItemChoisir={setNature} name='nature-envoie' />
                                            <div className='side-to-side-envoie'>
                                                <FormInput label='Poids en KG *' itemInput={weight} setItemInput={setWeight} auth />
                                                {
                                                    ((typeEnvoie.id === 1 || typeEnvoie.id === 2) && typeRamassage.id === 1)
                                                        ? (<FormInput label='Cout en Dinars' itemInput={`${cost} + Cout Ramassage`} setItemInput={setCost} auth />)
                                                        : (<FormInput label='Cout en Dinars' itemInput={cost} setItemInput={setCost} auth />)
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className='button'>
                                        <span className='active' onClick={() => navigate('/envois/1')}>Retour</span>
                                    </div>


                                </div>
                            )
                        )
                    )
                }
            </div>
        </div>
    )
}
export default DetailEnvoie